export type StoreAppReturnStatus =
  "booked" | "paid" | "payment_pending" | "payment_failed";

export const parseStoreReturnUrl = (value: string | null): string | null => {
  if (
    !value ||
    !/^alloweat:\/\//i.test(value) ||
    Array.from(value).some(
      character =>
        character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127,
    )
  )
    return null;

  try {
    const url = new URL(value);
    return url.protocol === "alloweat:" && !url.username && !url.password
      ? url.href
      : null;
  } catch {
    return null;
  }
};

export const storeAppReturnHref = (
  returnUrl: string | null,
  status: StoreAppReturnStatus | null,
): string | null => {
  const parsed = parseStoreReturnUrl(returnUrl);
  if (!parsed) return null;

  const url = new URL(parsed);
  if (status) url.searchParams.set("status", status);
  else url.searchParams.delete("status");
  return url.href;
};
